export default __webpack_public_path__ + "845bf39af78653aa789f3997ff64f92e.svg";